import React from "react";

/** Cartão "fantasma" com brilho enquanto os números chegam (pedido do dono). */
export function CartaoCarregando() {
  return (
    <div className="vg-tk" aria-hidden="true">
      <div className="vg-tk-top">
        <span className="vg-skel h-3.5 w-24" />
        <span className="vg-skel h-[30px] w-[30px]" />
      </div>
      <span className="vg-skel h-8 w-32" />
      <span className="vg-skel h-2.5 w-full" />
      <span className="vg-skel h-2 w-2/3" />
      <span className="vg-skel h-5 w-full mt-auto" />
    </div>
  );
}

/** Bloco retangular (gráfico, tabela) carregando. */
export function BlocoCarregando({ altura = 240 }) {
  return <div className="vg-skel w-full" style={{ height: altura }} aria-label="Carregando" />;
}

/** Linhas de tabela carregando. */
export function LinhasCarregando({ n = 6 }) {
  return (
    <div className="flex flex-col gap-3 py-1" aria-label="Carregando">
      {Array.from({ length: n }, (_, i) => (
        <div key={i} className="flex items-center gap-3">
          <span className="vg-skel h-7 w-7 rounded-full" />
          <span className="vg-skel h-3 flex-1" />
          <span className="vg-skel h-3 w-20" />
        </div>
      ))}
    </div>
  );
}

export function ErroBloco({ onTentar }) {
  return (
    <div className="vg-vazio">
      Não deu para carregar este bloco.{" "}
      {onTentar && <button className="font-semibold text-[color:var(--vg-brand)]" onClick={onTentar}>Tentar de novo</button>}
    </div>
  );
}
